export default __webpack_public_path__ + "static/media/misRecetas.43a76c27.svg";